import { OsaComment } from "../models/OsaComment";

export enum CommentFilterOption {
  All = "all",
  Resolved = "resolved",
  Unresolved = "unresolved",
}

export const isOsaWayComment = (comment: OsaComment) => !comment.osaNodeId;

export const isNodeComment = (comment: OsaComment, osaNodeId: string) =>
  comment.osaNodeId === osaNodeId;

export const isMainThreadResolved = (
  allComments: OsaComment[],
  actualComment: OsaComment
) => {
  if (!actualComment.mainThreadId) return actualComment.resolved;
  return allComments.find((comm) => comm.id === actualComment.mainThreadId)
    ?.resolved;
};

export const countThreadsAndReplies = (comments: OsaComment[]) =>
  comments.reduce((total, comment) => total + comment.replies.length + 1, 0);

export const filterCommentByOption = (
  comment: OsaComment,
  option: CommentFilterOption
) => {
  switch (option) {
    case CommentFilterOption.All:
      return true;
    case CommentFilterOption.Resolved:
      return comment.resolved;
    case CommentFilterOption.Unresolved:
      return !comment.resolved;
    default:
      return false;
  }
};
